export default "__VITE_ASSET__D8en0zEG__"